import { Clickable, P } from '@ahmdigital/ui';

export const ABOUT_US_DESCRIPTION = (
  <P>
    ahm is an Australian insurance provider backed by the{' '}
    <Clickable to="https://www.medibank.com.au/about/company/overview/purpose/">Medibank group</Clickable>, one of the
    largest health insurance companies in Australia. For more than 50 years, we’ve helped over one million Aussies with
    insurance for health, travel, pet, car and more - while doing things a little differently along the way.
  </P>
);

export const MEET_THE_CREW_DESCRIPTION = (
  <>
    <P>We’re home grown Aussies and we’ve got some of the most knowledgeable support going around.</P>
    <P>
      You can manage heaps of stuff in our app — but if you’d rather talk to a real person, we’ve got you. Our contact
      centre is based in Wollongong and always here to help. Monday to Friday, 9am – 6pm AEST. Call us on{' '}
      <Clickable to="tel:134246">13 42 46</Clickable>
    </P>
  </>
);

export const INSURANCE_THINGS_DESCRIPTION = (
  <>
    <P>We’re all complex creatures, so we don’t think wellness should look the same for everyone.</P>
    <P>
      Maybe your version of feeling good is smashing a PB. Maybe it’s finally booking that physio appointment you’ve
      been putting off for months. Or maybe it’s taking a Sunday to properly switch off and do absolutely nothing for a
      change.
    </P>
    <P>Whatever wellness looks like to you, we’re here to back it.</P>
    <P>
      At ahm, we believe insurance should feel simpler, more straightforward and a little more human. That means
      practical cover, clear information and support that fits around real life, not the other way around.
    </P>
  </>
);

export const IMPORTANT_STUFF_DESCRIPTION = (
  <>
    ahm is proud to have played a key role in creating the{' '}
    <Clickable to="https://privatehealthcareaustralia.org.au/codeofconduct/">
      Private Health Insurance Code of Conduct.
    </Clickable>{' '}
    It exists to protect you — making sure health insurers give clear, consistent information about their products and
    services. Because you deserve to know exactly what you’re getting.
  </>
);

export const GOOD_BUNCH_DESCRIPTION = (
  <>
    <P>
      We’ve got a strong culture, a supportive crew and a shared love for making insurance feel a little more human.
    </P>
    <P>
      Curious about who’s behind the scenes (or thinking of joining us)?{' '}
      <Clickable to="https://careers.medibank.com.au/careers/ahm/">Explore ahm careers here</Clickable>
    </P>
    <P>(Warning: may include friendly faces and people who really love a game of pickleball.)</P>
  </>
);

export const FOOTNOTE = 'Ready to find great value private health insurance that actually works for you?';
